import type { IconProps } from './icons';
import { createSvgIcon } from './icons';

export default function ChevronRightIcon(props: IconProps) {
    const svg = <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 -960 960 960" width="100%" fill="#currentColor">
                    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                </svg>
    return (
        createSvgIcon(svg, props)
    );
}
